<template>
  <div class="max-w-full relative" @click="didToggleBlur">
    <div class="overflow-hidden my-3 rounded">
      <div
        v-show="!shouldShow"
        class="message-image__image message-image__image--placeholder"
        :style="{ height: placeholderHeight, width: placeholderWidth }"
      ></div>
      <img
        :src="url"
        v-on:load="loaded"
        v-show="shouldShow"
        class="message-image__image"
        :class="{'message-image__image--blurred': !shouldReveal}"
      >
      <div class="absolute inset-0 w-full h-full flex items-center justify-center bg-gray-400 rounded opacity-50" v-show="!shouldReveal">
        <div class="font-bold text-black text-center text-sm opacity-100 px-2 select-none">{{narrative}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['url', 'height', 'width'],

  data() {
    return {
      shouldShow: false,
      shouldReveal: false
    }
  },

  methods: {
    didToggleBlur() {
      if (this.shouldShow) {
        this.shouldReveal = !this.shouldReveal
      }
    },

    loaded() {
      this.shouldShow = true
    }
  },

  computed: {
    narrative() {
      if (this.shouldShow) {
        return 'Reveal'
      } else {
        return 'Loading'
      }
    },

    placeholderHeight() {
      if (this.height === null) {
        return '300px'
      } else if (this.height === 0) {
        return '300px'
      } else {
        return this.height + 'px'
      }
    },

    placeholderWidth() {
      if (this.width === null) {
        return '300px'
      } else if (this.width === 0) {
        return '300px'
      } else {
        return this.width + 'px'
      }
    }
  }
}
</script>
